import { useState } from 'react'

import {
  Hydrate,
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query'

import { api } from '@/shared/lib/api'

export const QueryProvider = ({ dehydratedState, children }) => {
  const defaultQueryFn = async ({ queryKey }) => {
    const { data } = await api.get(queryKey[0])

    return data
  }

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnReconnect: true,
            refetchOnWindowFocus: false,
            refetchInterval: 0,
            refetchIntervalInBackground: 60000,
            retry: true,
            refetchOnMount: true,
            retryDelay: attempt =>
              Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
            queryFn: defaultQueryFn
          }
        }
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={dehydratedState}>{children}</Hydrate>
    </QueryClientProvider>
  )
}
